<template>
  <v-container>
    <div id="grid-usuario">
      <v-card>
        <v-toolbar card color="white" xs12>
          <v-toolbar-title class="indigo--text">Usuarios</v-toolbar-title>
          <v-btn color="primary" @click="newUser()">Crear Usuario</v-btn>
        </v-toolbar>
        <v-divider></v-divider>

        <v-container color="white">
          <v-layout>
            <v-flex md2>
              <v-select
                v-model="tipoUsuariosValue"
                :items="tipoUsuariosSelect"
                item-text="name"
                item-value="code"
                label="Tipo de Usuarios"
              ></v-select>
            </v-flex>

            <v-flex>
              <v-text-field v-model="emailValue" label="Email"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="rutValue" label="RUT"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="nombreValue" label="Nombre"></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-select
                v-model="estadoValue"
                :items="estadoSelect"
                item-text="name"
                item-value="code"
                label="Estado"
              ></v-select>
            </v-flex>

            <v-btn
              fab
              dark
              color="teal"
              title="Filtrar detalle"
              @click="loadDataUsuarios()"
            >
              <v-icon dark>filter_list</v-icon>
            </v-btn>
            <v-btn
              fab
              dark
              color="red darken-4"
              title="Limpiar filtros"
              @click="clear()"
            >
              <v-icon dark>clear_all</v-icon>
            </v-btn>
          </v-layout>
        </v-container>
      </v-card>
      <v-layout justify-center>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>

          <v-data-table
            :headers="headers"
            :items="usuarios"
            :search="search"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.descTipo }}</td>
              <td class="text-xs-left">{{ props.item.usuEmail }}</td>
              <td class="text-xs-left">{{ props.item.rut }}</td>
              <td class="text-xs-left">
                {{ props.item.usuNombre }} {{ props.item.usuApellido }}
              </td>
              <td class="text-xs-left">{{ props.item.descEstado }}</td>
              <td class="text-xs-left">{{ props.item.usuFechaCreacion }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Ver usuario"
                  @click="viewUser(props.item.usuEmail)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Editar usuario"
                  @click="editUser(props.item.usuEmail)"
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.descEstado != 'Activo'"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Activar usuario"
                  @click="
                    openDeleteDialog(
                      props.item.idUsuario,
                      props.item.usuNombre,
                      props.item.usuApellido,
                      props.item.descEstado
                    )
                  "
                >
                  <v-icon>check</v-icon>
                </v-btn>

                <v-btn
                  v-if="props.item.descEstado == 'Activo'"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="red darken-4"
                  small
                  title="Bloquear usuario"
                  @click="
                    openDeleteDialog(
                      props.item.idUsuario,
                      props.item.usuNombre,
                      props.item.usuApellido,
                      props.item.descEstado
                    )
                  "
                >
                  <v-icon>lock</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>

          <!-- LEYENDA TABLA USUARIO -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >&nbsp;Ver usuario
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="primary"
              small
            >
              <v-icon>open_in_new</v-icon> </v-btn
            >&nbsp;Editar usuario
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="red darken-4"
              small
            >
              <v-icon>lock</v-icon> </v-btn
            >&nbsp;Bloquear
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>check</v-icon> </v-btn
            >&nbsp;Activar
          </v-card-actions>
        </v-flex>
      </v-layout>

      <!-- dialogo de eliminacion (dar de baja)    -->
      <v-dialog v-model="dialogUser" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Esta seguro?</v-card-title>
          <v-card-text>Esta seguro que desea realizar esta accion.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialogUser = false"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" flat @click="modEstadoUsuario()"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import LoadingEnviando from "@/views/ui/Loading.vue";

export default {
  name: "grid-usuario",
  components: {
    Loading,
    LoadingEnviando,
  },
  props: {
    tipoUsuario: String,
    tipeView: String,
  },
  data() {
    return {
      loading: false,
      userToDelete: "",
      userToReset: "",
      usuarios: [],
      // TODO cambiar funcionalidad de estado usuario de texto a un id: 'activo'
      dialogUser: false,
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        {
          text: "Tipo Usuario",
          align: "left",
          sortable: false,
          value: "tipoUsuario",
        },
        { text: "Email", align: "left", sortable: false, value: "email" },
        { text: "RUT", align: "left", sortable: false, value: "rut" },
        { text: "Nombre completo", sortable: false, value: "nombreCompleto" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Fecha creación", sortable: false, value: "fechaAcceso" },
        { text: "Acciones", sortable: false, value: "" },
      ],
      id: Number,
      editedIndex: -1,

      // dsoto
      // tipoUsuarioValue: null,
      tipoUsuariosSelect: [
        { name: "AGENCIA", code: 0 },
        { name: "PROVEEDOR", code: 1 },
        { name: "ADMINISTRADOR", code: 2 },
      ],
      tipoUsuariosValue: null,
      estadoSelect: [
        { name: "ACTIVO", code: 0 },
        { name: "BLOQUEADO", code: 1 },
        // {name: 'ELIMINADO', code: 3},
      ],
      estadoValue: null,
      listRol: [],
      // rolUsuarioValue: null,
      rolUsuarioSelect: [],
      search: "",
      nombreUsuario: "",
      apellidoUsuario: "",
      estadoUsuario: "",
      idUsuario: "",
      nombreValue: "",
      emailValue: "",
      rutValue: "",
      body: [],
    };
  },

  created() {},
  mounted() {
    this.loadDataUsuarios();
  },
  computed: {},
  methods: {
    async loadDataUsuarios() {
      this.loading = true;
      this.usuarios = await this.loadUsers();
      this.loading = false;
    },

    async loadUsers() {
      let body = {
        nombre: this.nombreValue,
        estado: this.estadoValue,
        tipo: this.tipoUsuariosValue,
        username: this.emailValue,
        rut: this.rutValue,
      };
      // console.log("st::this.body:" + JSON.stringify(body, null, 2));
      return await axios
        .post("/usuarios/filtros", body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log("error userFiltro:" + error);
          return [];
        });
    },

    newUser() {
      setTimeout(() => {
        this.$router.push({
          name: "UsuarioRegistrar",
          params: { tipeView: "crear" },
        });
      }, 1000);
    },

    viewUser(username) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "UsuarioRegistrar",
          params: { username: username, tipeView: "consulta" },
        });
      }, 1000);
    },
    editUser(username) {
      this.$router.push({
        name: "UsuarioRegistrar",
        params: { username: username, tipeView: "modifica" },
      });
    },
    openDeleteDialog(user, nombre, apellido, estado) {
      this.idUsuario = user;
      this.nombreUsuario = nombre;
      this.apellidoUsuario = apellido;
      this.estadoUsuario = estado;

      this.userToDelete = user;
      this.dialogUser = true;
    },
    async deleteUser() {
      await this.delete();

      this.reloadGrid();
    },
    async delete() {
      let idUserLogged = this.$store.getters.userLogged.id;
      return await axios
        .delete("/user/" + this.userToDelete + "/" + idUserLogged)
        .then(function (response) {
          response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //dsoto
    async modEstadoUsuario() {
      this.dialogUser = false;
      var result = await this.modEstado();
      if (result) {
        this.loadDataUsuarios();
        this.dialogUser = false;
      }
    },
    modEstado() {
      axios
        .get("/user/cambiaEstado/" + this.idUsuario)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_UPDATE");
          return true;
        })
        .catch(function (error) {
          console.log(error);
          window.getApp.$emit("APP_PROCESS_ERROR");
          return true;
        });
    },
    //dsoto

    reloadGrid() {
      this.dialog = false;
      if (this.tipoUsuario == "AGENCIA") {
        this.$parent.$parent.reloadAgenciaUser();
      }
      if (this.tipoUsuario == "PROVEEDOR") {
        this.$parent.$parent.reloadProveedorUser();
      }
    },

    // dsoto
    /*async loadRol() {
      this.rolUsuarioSelect = [];
      this.listRol = await this.loadRolTipoUsuario();
      this.loadRolUsuario();
    },

    async loadRolTipoUsuario() {
      return await axios
        .get("/roles/tipoUsuario/" + this.tipoUsuarioValue)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    loadRolUsuario() {
      let com = [];
      this.rolUsuarioSelect = [];
      this.listRol.forEach(function (d) {
        let index = com.findIndex((x) => x.id == d.id);

        if (index === -1) {
          com.push({ name: d.nombre, code: d.id });
        }
      });
      this.rolUsuarioSelect = com;
    },*/
    //dsoto

    clear() {
      // this.tipoUsuarioValue = null;
      // this.rolUsuarioValue = null;
      this.tipoUsuariosValue = null;
      this.nombreValue = "";
      this.estadoValue = null;
      this.rutValue = "";
      this.emailValue = "";
      this.loadDataUsuarios();
    },
  },
};
</script>
